import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-qr-import',
  standalone: false,
  template: `
    <section class="qr-import">
      <div class="history-header">
        <h2>Mass Import</h2>
      </div>

      <ion-list lines="full">
        <ion-item>
          <ion-label position="stacked">CSV</ion-label>
          <input class="file-input" type="file" accept=".csv,text/csv" aria-label="Import QR code CSV" (change)="csvSelected.emit($event)">
        </ion-item>
      </ion-list>

      <div class="qr-import-actions">
        <ion-button type="button" fill="outline" (click)="downloadTemplate.emit()">CSV Template</ion-button>
      </div>

      <ion-note color="medium" *ngIf="message">{{ message }}</ion-note>
      <ion-note color="danger" *ngIf="errors.length > 0">
        {{ errors.join(' ') }}
      </ion-note>
    </section>
  `
})
export class QrImportComponent {
  @Input() message = '';
  @Input() errors: string[] = [];

  @Output() csvSelected = new EventEmitter<Event>();
  @Output() downloadTemplate = new EventEmitter<void>();
}
